import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { editText, moreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { commentsOpen } from '../annotations/CommentCommands';
import { tagsAddNew } from '../annotations/TaggingCommands';
import { jiraCreateIssuesFrom } from '../atlassian/AtlassianCommands';
import { JiraInfo } from '../atlassian/JiraInfo';
import { connectorBunch, connectorCreateFromSelection, connectorSpread } from '../connector/ConnectorCommands';
import { IndexCard } from './IndexCard';

export const indexCardPropertyLayout = LockablePropertyStripLayout<IndexCard>((d, s, o, w, a) => {
    const jira = s.get(JiraInfo)?.enabled;
    const connectors = a.map(x => x.relations('attached').length >= 2).find(x => !!x);
    return [
        ...editText(d, s, o, w, a),
        w.createDivide(),
        //
        // Auto Color
        w.createColorSelector({
            allowNull: true,
            value: a.get('color'),
            text: 'Card Color',
            onSelect() {
                o.update(() => a.set('color', this.value!));
            }
        }),
        w.createButton({
            image: 'deqo://icons/d2/connector',
            text: 'Connect To...',
            onAction() {
                d(connectorCreateFromSelection);
            }
        }),
        ...(!!connectors ? [
            w.createButton({
                image: 'deqo://icons/d2/connector-bunch',
                text: 'Connector Bunch',
                onAction() {
                    d(connectorBunch);
                }
            }),
            w.createButton({
                image: 'deqo://icons/d2/connector-spread',
                text: 'Connector Spread',
                onAction() {
                    d(connectorSpread);
                }
            }),
        ] : []),
        ...(a.count === 1 ? [
            w.createButton({
                image: 'deqo://icons/d2/comment-small',
                text: 'Add Comment',
                onAction() {
                    d(commentsOpen, [a.get('id'), true]);
                }
            }),
            w.createButton({
                image: 'deqo://icons/hero/tag',
                text: 'Add Tag',
                onAction() {
                    d(tagsAddNew, [a.get('id')]);
                }
            }),
        ] : []),
        ...(!!jira ? [
            w.createButton({
                image: 'deqo://icons/d2/jira',
                text: 'Create Jira Issues',
                onAction() {
                    d(jiraCreateIssuesFrom);
                }
            }),
            w.createDivide(),
        ] : []),
        ...moreLayout(d, s, o, w, a),
    ];
});
